import React, { useEffect } from 'react'
import Message from './Message'
import useGetMessages from '../hooks/useGetMessages';
import { useSelector, useDispatch } from "react-redux";
import useGetRealTimeMessage from '../hooks/useGetRealTimeMessage';
import moment from 'moment';
import axios from 'axios';
import { BASE_URL } from '../config';

const Messages = () => {
    const { selectedUser, authUser } = useSelector(store => store.user);
    const { messages } = useSelector(store => store.message);
    const dispatch = useDispatch();

    // Always call the hooks, but they should handle the case when selectedUser is null
    useGetMessages();
    useGetRealTimeMessage();
    
     // Ensure messages is always an array, default to empty array if null/undefined
    const messagesArray = Array.isArray(messages) ? messages : []
    
    
    const filteredMessages = messagesArray.filter(msg => {
        if (!msg || !msg.senderId || !msg.receiverId) return false;
    
     
        // For Admin: Show messages with selected user
        if (authUser?.isRole === 1) {
            return (
            
                // (msg.senderId === selectedUser?._id && msg.receiverId === authUser._id) ||
                // (msg.senderId === authUser._id && msg.receiverId === selectedUser?._id) ||
                // (msg.isBroadcastToAdmins && msg.senderId === selectedUser?._id)
                msg.senderId === selectedUser?._id || 
                msg.receiverId === selectedUser?._id
            );
        }
        // For User: Show all messages to/from any admin
        else {
            return (
                msg.senderId === authUser?._id || 
                msg.receiverId === authUser?._id 
                // (msg.senderId === authUser?._id && msg.receiverId === 'admins') ||
                // (msg.receiverId === authUser?._id && msg.senderId === 'admins') ||
               
                // (msg.isBroadcastToAdmins && msg.senderId === authUser?._id)
            );
        }
    });


    // Mark messages as seen when they're viewed
    useEffect(() => {
        if (!selectedUser) return;

    
            const unseenMessages = filteredMessages.filter(
    msg => msg && msg.receiverId && msg.status && 
           msg.receiverId === authUser?._id && 
           msg.status !== "seen"
);

          


        if (unseenMessages?.length > 0) {
            const messageIds = unseenMessages.map(msg => msg._id);
            axios.post(`${BASE_URL}/api/v1/message/markAsSeen`, { 
                messageIds 
            }, { 
                withCredentials: true 
            });
        }
    }, [filteredMessages, authUser, selectedUser]);

    // Function to check if we should show date separator
    const shouldShowDate = (currentMsg, prevMsg) => {
        if (!prevMsg) return true; // First message
        
        const currentDate = moment(currentMsg.createdAt);
        const prevDate = moment(prevMsg.createdAt);
        
        // Show separator if dates are different
        return !currentDate.isSame(prevDate, 'day');
    };
    
    // Function to format date display
    const formatDate = (date) => {
        const msgDate = moment(date);
        const now = moment();
        
        if (now.diff(msgDate, 'days') > 7) {
            // More than 1 week old - show full date
            return msgDate.format('D MMMM YYYY');
        } else {
            // Within 1 week - show day name
            return msgDate.calendar(null, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday]',
                lastWeek: 'dddd',
                sameElse: 'dddd'
            });
        }
    };

    return (
         <div className='flex-1 overflow-auto pb-24 md:pb-0'>


            {filteredMessages && filteredMessages.map((message, index) => {
                const prevMessage = filteredMessages[index - 1];
                const showDate = shouldShowDate(message, prevMessage);
                
                return (
                    <React.Fragment key={message._id}>
                        {showDate && (
                            <div className="flex justify-center my-2">
                                <div className="bg-[#fff] text-gray-600 text-xs px-2 py-1 rounded-full">
                                    {formatDate(message.createdAt)}
                                </div>
                            </div>
                        )}
                        <Message message={message} />
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Messages; 